<template>
  <div v-if="isVisible" class="loading-overlay" :class="{ 'fade-out': isFading }">
    <div class="loading-content">
      <img 
        :src="loadingImage" 
        :alt="'Loading...'" 
        class="loading-icon"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isVisible: true,
      isFading: false,
      minDisplayTime: 1500, // 1.5 seconds minimum
      startTime: Date.now(),
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    loadingImage() {
      // Use white danseuse on mobile, black danseuse on desktop
      return this.isMobile 
        ? '/playground_assets/danseuse-white.png'
        : '/playground_assets/danseuse.png'
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    isLoading(newVal) {
      if (!newVal) {
        this.hideOverlay()
      }
    }
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    hideOverlay() {
      const elapsed = Date.now() - this.startTime
      const remainingTime = Math.max(0, this.minDisplayTime - elapsed)
      
      setTimeout(() => {
        this.isFading = true
        setTimeout(() => {
          this.isVisible = false
        }, 300) // Fade out duration
      }, remainingTime)
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease-out;
  background-color: #f5f5f5; /* Light grey for desktop */
}

.loading-overlay.fade-out {
  opacity: 0;
}

.loading-content {
  text-align: center;
}

.loading-icon {
  width: 96px;
  height: 96px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

/* Mobile styles */
@media (max-width: 768px) {
  .loading-overlay {
    background-color: #000000; /* Black background for mobile */
  }

  /* Default mobile offset (Android & others) – lowered for better vertical centering */
  .loading-content {
    transform: translateY(-5px);
  }

  /* iOS-specific tweak: lowered for better vertical centering */
  @supports (-webkit-touch-callout: none) {
    .loading-content {
      transform: translateY(-5px);
    }
  }

  /* On mobile, disable the pulse animation to avoid subtle vertical “glitch” during transform+scale */
  .loading-icon {
    animation: none;
  }
}
</style> 